import { get } from 'lodash';
import { api } from 'utils/hooks/useApi';
import { IOrganization, IOrganizationForm } from './_types';

const BASE_URL = '/portal-api/v1/organization';

// Create Organization
export const createOrganization = async (
  data: IOrganizationForm,
): Promise<IOrganization | null> => {
  const response = await api().put(`${BASE_URL}/create`, data);
  return get(response, 'data', null);
};

// Update Organization
export const updateOrganization = async (
  data: IOrganizationForm,
): Promise<IOrganization | null> => {
  const response = await api().post(`${BASE_URL}/update`, data);
  return get(response, 'data', null);
};

// Get Organization by ID
export const getOrganization = async (id: number): Promise<IOrganization | false> =>
  api()
    .get(`${BASE_URL}/get`, {
      params: { id },
    })
    .then((response) => get(response, 'data'))
    .catch((error) => false);

// Search Organizations
export const searchOrganizations = async (searchCriteria: {
  name?: string;
  city?: string;
  state?: string;
  active?: boolean;
}): Promise<IOrganization[] | false> =>
  api()
    .post(`${BASE_URL}/search`, searchCriteria)
    .then((response) => get(response, 'data'))
    .catch((error) => false);

// Delete Organization
export const deleteOrganization = async (id: number): Promise<boolean> =>
  api()
    .delete(`${BASE_URL}/delete`, { params: { id } })
    .then((response) => true)
    .catch((error) => false);
